import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, Form } from 'semantic-ui-react';

import * as cm_action from 'actions/commons';
import cm from 'helpers/commons';

class SikdaeGroup extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { commonsFn, groupIdx } = this.props;
    commonsFn.changeGroup({
      type: 'group',
      name: 'value',
      value: groupIdx ? groupIdx.value : null
    });
  }

  //식대 그룹 선택
  groupSearch = async (e, data) => {
    const { commonsFn, sikdaeGroupSearch } = this.props;
    await commonsFn.changeGroup({
      type: 'group',
      name: 'value',
      value: data.value === 0 ? null : data.value
    });

    // if(data.value === 0) {

    await commonsFn.changePolicy({
      type: 'policy',
      name: 'value',
      value: null
    });

    // }

    if (sikdaeGroupSearch) {
      sikdaeGroupSearch();
    }
  };

  render() {
    let group = null;
    const { sikdaeGroup, label, input, defaultValue, groupIdx, style, isLabel, isDim } = this.props,
      defaultOptions = [{ value: 0, text: '식대그룹 전체' }];
    let def = 0;

    // 조회 중·실패 시 sikdaeGroup이 비어 있거나 data가 없을 수 있다
    const hasGroupData = !!(sikdaeGroup && sikdaeGroup.data && sikdaeGroup.data.group);

    if (hasGroupData) {
      group = cm.selectDataForMat(sikdaeGroup.data.group, '식대그룹 전체');
    }

    if (defaultValue) {
      def = defaultValue;
    }

    return (
      <Form.Field inline style={style} className="com-sikdae-group">
        {isLabel ? <label style={label}>식대그룹 *</label> : null}

        {hasGroupData ? (
          <Dropdown
            selection
            style={input}
            disabled={isDim}
            placeholder="식대그룹 전체"
            value={groupIdx && groupIdx.value ? groupIdx.value : def}
            options={group}
            onChange={this.groupSearch}
          />
        ) : (
          <Dropdown
            placeholder="식대그룹 전체"
            selection
            disabled
            defaultValue={0}
            options={defaultOptions}
            style={input}
          />
        )}
      </Form.Field>
    );
  }
}

SikdaeGroup = connect(
  (state) => ({
    groupIdx: state.commons.group,
    sikdaeGroup: state.commons.sikdaeGroup
  }),
  (dispatch) => ({
    commonsFn: bindActionCreators(
      {
        changeGroup: cm_action.ReduxDataSet,
        changePolicy: cm_action.ReduxDataSet
      },
      dispatch
    )
  })
)(SikdaeGroup);

export default SikdaeGroup;
